import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import SwitchServiceIcons from '@/icons/SwitchServiceIcons'
import { getAllServicesByCustomerID } from '@/modules/Service/services'
import { generatePathDatacentral } from '@/utils/path'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IconButton, Select, Typogaphy } from 'vnetwork-ui'
interface CustomerServiceProps {
    customerID: number
    serviceID: number
}
const SwitchCustomerService: React.FC<CustomerServiceProps> = ({
    customerID,
    serviceID,
}) => {
    const { t } = useTranslation('services')
    const [isSwitching, setIsSwitching] = useState(false)
    const navigate = useNavigate()
    const { data, isPending, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.SERVICES, customerID],
        queryFn: () =>
            getAllServicesByCustomerID({ customer_id: customerID }, t),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (!data) return null

    return (
        <div className="min-w-[300px] max-w-full flex flex-col gap-2">
            {isSwitching ? (
                <Select
                    loading={isPending}
                    onChange={(value) => {
                        navigate(
                            generatePathDatacentral('/services/:id', {
                                id: value,
                            })
                        )
                        setIsSwitching(false)
                    }}
                    allowClear={false}
                    disabled={data?.length <= 1}
                    options={data}
                    value={serviceID}
                />
            ) : (
                <div className="flex gap-2">
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-md px-4 py-2 w-full">
                        <Typogaphy className="font-medium text-primary line-clamp-1">
                            {
                                data?.find(
                                    (service) => service.value === serviceID
                                )?.label
                            }
                        </Typogaphy>
                    </div>
                    <IconButton
                        onClick={() => setIsSwitching(true)}
                        size="small"
                    >
                        <SwitchServiceIcons className="w-4 h-4 text-primary" />
                    </IconButton>
                </div>
            )}
        </div>
    )
}

export default SwitchCustomerService
